import React from "react";
import { motion } from "framer-motion";

interface AuctionTypeCardProps {
  auction: {
    icon: React.ReactNode;
    title: string;
    duration: string;
    description: string;
    features: string[];
    color: string;
    gradient: string;
    glowColor: string;
  };
  index: number;
}

const AuctionTypeCard: React.FC<AuctionTypeCardProps> = ({
  auction,
  index,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: index * 0.1 }}
      viewport={{ once: true }}
      className={`${auction.gradient} rounded-xl p-4 md:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 h-full flex flex-col overflow-hidden`}
    >
      <div
        className={`inline-flex p-2 md:p-3 rounded-full bg-gradient-to-br ${auction.color} text-white mb-3 md:mb-4 self-start`}
      >
        {auction.icon}
      </div>

      <div className="mb-2 md:mb-3">
        <div
          className={`inline-block px-2 py-1 rounded-full text-xs font-semibold bg-gradient-to-r ${auction.color} text-white`}
        >
          {auction.duration}
        </div>
      </div>

      <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 md:mb-3 break-words">
        {auction.title}
      </h3>

      <p className="text-sm text-gray-600 mb-3 md:mb-4 flex-grow break-words">
        {auction.description}
      </p>

      <ul className="space-y-1 md:space-y-2">
        {auction.features.map((feature, featureIndex) => (
          <li
            key={featureIndex}
            className="flex items-center text-gray-700 text-sm break-words"
          >
            <div
              className={`w-2 h-2 rounded-full bg-gradient-to-r ${auction.color} mr-2 flex-shrink-0`}
            />
            {feature}
          </li>
        ))}
      </ul>
    </motion.div>
  );
};

export default AuctionTypeCard;
